export const PostBedHistory = async (resource,data) => {
    let result
    await resource
        .post(`api/${localStorage.getItem('perfil')}/bed_history`,data)
        .then(
            (response) => {
                result = response.body.bed_history
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const PutBedhistory = async (resource, id, data) => {
    let result
    await resource
        .put(`api/${localStorage.getItem('perfil')}/bed_history/${id}`, data)
        .then(
            (response) => {
                result = response.body.bed_history
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const BedHistoryFindByUpdatedAt = async (resource,date) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/bed_history/find_by_updated_at/${date}`)
        .then(
            (response) => {
                result = response.body.bed_history
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const BedHistoryFindByBedId = async (resource,id) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/bed_history/find_by_bed_id/${id}`)
        .then(
            (response) => {
                result = response.body.bed_history
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}

export const BedHistoryFindByUpdatedAtAndStablishment = async (resource, date, stablishmentId) => {
    let result
    await resource
        .get(`api/${localStorage.getItem('perfil')}/bed_history/find_by_updated_at_and_stablishment_id/${date}/${stablishmentId}`)
        .then(
            (response) => {
                result = response.body.bed_history
            },
            (response) => {
                console.log(response);
            }
        );
    return result;
}